import { UpdateWorkOrderStatusDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workOrderApi } from "../service";
import { workOrderKeys } from "../work-order.keys";
import { auditLogKeys } from "../../../audit-log";

/**
 * Sets an Auftrag's status by hand. The answer is the whole work order, so the detail page is
 * updated from it directly rather than waiting for a refetch — the badge changes with the click.
 * The lists show the status too, and the audit log has just gained an entry.
 */
export function useUpdateWorkOrderStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      workOrderId,
      dto,
    }: {
      workOrderId: string;
      dto: UpdateWorkOrderStatusDto;
    }) => {
      const { data } = await workOrderApi.updateStatus(workOrderId, dto);
      return data;
    },
    onSuccess: (data, { workOrderId }) => {
      queryClient.setQueryData(workOrderKeys.detail(workOrderId), data);
      queryClient.invalidateQueries({ queryKey: workOrderKeys.lists() });
      queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(workOrderId) });
    },
  });
}
